import { Checkbox } from '@thoughtspot/radiant-react/widgets/checkbox';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import React, { useRef, useState } from 'react';
const REVEAL_BATCH_SIZE = 100;
const LOAD_MORE_SCROLL_THRESHOLD_PX = 48;
export const ProgressiveCheckboxList = ({ className, items, checkedItems, onItemChange, disabledPredicate, }) => {
    const [visibleCount, setVisibleCount] = useState(REVEAL_BATCH_SIZE);
    const prevItemsRef = useRef(items);
    let effectiveCount = visibleCount;
    if (prevItemsRef.current !== items) {
        prevItemsRef.current = items;
        effectiveCount = REVEAL_BATCH_SIZE;
        if (visibleCount !== REVEAL_BATCH_SIZE) {
            setVisibleCount(REVEAL_BATCH_SIZE);
        }
    }
    const handleScroll = (e) => {
        const el = e.currentTarget;
        const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        if (distanceFromBottom <= LOAD_MORE_SCROLL_THRESHOLD_PX) {
            setVisibleCount(prev => Math.min(prev + REVEAL_BATCH_SIZE, items.length));
        }
    };
    return (React.createElement(Vertical, { className: className, onScroll: handleScroll }, items.slice(0, effectiveCount).map((item) => (React.createElement(Checkbox, { id: item.id, key: item.id, label: item.name, checked: checkedItems.has(item.id), isList: true, onChange: e => onItemChange(e, item), disabled: disabledPredicate?.(item.id), showTooltipOnEllipsis: true, tooltipContent: item.name })))));
};
//# sourceMappingURL=progressive-checkbox-list.js.map